/**
 * Translates a category name using the `categoryNames` i18n keys.
 * Falls back to the original English name if no translation exists.
 */
export function useCategoryTranslation() {
  const { t, te } = useI18n();

  function translateCategory(name: string): string {
    const key = `categoryNames.${name}`;
    return te(key) ? t(key) : name;
  }

  return { translateCategory };
}
